import {
  FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_START,
  FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_COMPLETE,
  FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_ERROR,
  GRANT_EMR_MANAGER_ROLE_TO_ADMIN_START,
  GRANT_EMR_MANAGER_ROLE_TO_ADMIN_SUCCESS,
  GRANT_EMR_MANAGER_ROLE_TO_ADMIN_ERROR,
  REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_START,
  REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_SUCCESS,
  REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_ERROR
} from './action-types';

export const fetchGrantRevokeEmrManagerRoleButtonsStart = ({ currentAdminId, adminIds }) => ({
  type: FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_START,
  payload: { currentAdminId, adminIds }
});

export const fetchGrantRevokeEmrManagerRoleButtonsComplete = ({ shouldDisplay, admins }) => ({
  type: FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_COMPLETE,
  payload: { shouldDisplay, admins }
});

export const fetchGrantRevokeEmrManagerRoleButtonsError = ({ error }) => ({
  type: FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_ERROR,
  payload: { error }
});

export const grantEmrManagerRoleToAdminStart = ({ adminId }) => ({
  type: GRANT_EMR_MANAGER_ROLE_TO_ADMIN_START,
  payload: { adminId }
});

export const grantEmrManagerRoleToAdminSuccess = ({ adminId }) => ({
  type: GRANT_EMR_MANAGER_ROLE_TO_ADMIN_SUCCESS,
  payload: { adminId }
});

export const grantEmrManagerRoleToAdminError = ({ error, adminId }) => ({
  type: GRANT_EMR_MANAGER_ROLE_TO_ADMIN_ERROR,
  payload: { error, adminId }
});

export const revokeEmrManagerRoleFromAdminStart = ({ adminId }) => ({
  type: REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_START,
  payload: { adminId }
});

export const revokeEmrManagerRoleFromAdminSuccess = ({ adminId }) => ({
  type: REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_SUCCESS,
  payload: { adminId }
});

export const revokeEmrManagerRoleFromAdminError = ({ error, adminId }) => ({
  type: REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_ERROR,
  payload: { error, adminId }
});
